// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-details {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  font-family: Roboto, arial, sans-serif;
}

.contact-avatar {
  height: 140px;
  width: 140px;
  border-radius: 50%;
  overflow: hidden;
}

.contact-avatar img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.contact-name {
  line-height: 25px;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  margin-top: 15px;
  max-width: 90%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
}

.contact-organization {
  font-size: 14px;
  color: rgb(151, 151, 151);
  margin-top: 10px;
  max-width: 90%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
}

.contact-location {
  font-size: 14px;
  color: #888;
  margin-top: 4px;
  max-width: 90%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
}

.contact-id {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  word-break: break-all;
  overflow-wrap: break-word;
  max-width: 90%;
  text-align: center;
}

.contact-list-toggle {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Contacts/ContactView/ContactDetails.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".contact-details {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  font-family: Roboto, arial, sans-serif;\n}\n\n.contact-avatar {\n  height: 140px;\n  width: 140px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.contact-avatar img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.contact-name {\n  line-height: 25px;\n  font-size: 21px;\n  font-weight: bold;\n  color: rgb(0, 0, 0);\n  margin-top: 15px;\n  max-width: 90%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  text-align: center;\n}\n\n.contact-organization {\n  font-size: 14px;\n  color: rgb(151, 151, 151);\n  margin-top: 10px;\n  max-width: 90%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  text-align: center;\n}\n\n.contact-location {\n  font-size: 14px;\n  color: #888;\n  margin-top: 4px;\n  max-width: 90%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  text-align: center;\n}\n\n.contact-id {\n  font-size: 12px;\n  color: #999;\n  margin-top: 8px;\n  word-break: break-all;\n  overflow-wrap: break-word;\n  max-width: 90%;\n  text-align: center;\n}\n\n.contact-list-toggle {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
